module.exports = __webpack_public_path__ + "img/BCG_Platinion_Online_Color_Light.2de3dd22.png";